import React from 'react'
import clsx from 'clsx'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import Markdown from 'react-markdown'
import { motion } from 'framer-motion'
import { Container, Columns, Column } from 'bloomer'
import { useInView } from 'react-intersection-observer'

// Motion Variants
import * as motionVariants from './motion.variants'

// Styles
import styles from './style.module.scss'

export const PageContent = ({
  currentDepartment,
  departments,
  title: titleProps,
  description: descriptionProps,
}) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.3,
  })

  const [title, setTitle] = React.useState(titleProps)
  const [description, setDescription] = React.useState(descriptionProps)

  React.useEffect(() => {
    if (!isEmpty(departments) && !isEmpty(currentDepartment)) {
      const { description: newDesc, name: newTitle } = departments.find(
        ({ department_id }) => department_id === currentDepartment,
      )

      title !== newTitle && setTitle(newTitle)
      description !== newDesc && setDescription(newDesc)
    } else {
      title !== titleProps && setTitle(titleProps)
      description !== descriptionProps && setDescription(descriptionProps)
    }
  }, [currentDepartment])

  return (
    <div className={clsx('section', styles.section)} ref={ref}>
      <motion.div
        initial="hidden"
        variants={motionVariants.container}
        animate={inView ? 'visible' : 'hidden'}>
        <Container>
          <Columns>
            <Column isSize={{ default: 8 }}>
              <div className={clsx(' vacancy-content-wrapper', styles.content_wrapper)}>
                <motion.div variants={motionVariants.child}>
                  <h2 className={clsx('section-title', styles.section_title)}>{title}</h2>
                </motion.div>
                <motion.div variants={motionVariants.child}>
                  <Markdown
                    className={clsx('section-copy', styles.section_copy)}
                    source={description}
                  />
                </motion.div>
              </div>
            </Column>
          </Columns>
        </Container>
      </motion.div>
    </div>
  )
}

PageContent.defaultProps = {
  title: 'title',
  description: 'description',
  departments: [],
}

PageContent.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  departments: PropTypes.array,
  currentDepartment: PropTypes.any,
}

export default PageContent
